import { format } from 'owa-localize';

import { makePostRequest } from './executeHttpAction';

const TELEMETRY_URL_FORMAT = '/actions/{0}/clientTelemetry/';
const USER_MAILBOX_ID = 'mailboxId';

export default async function getConnectorsTokenAndLogTelemetry(
    payload: any,
    groupSmtpAddress: string
) {
    let requestUrl: string;
    if (groupSmtpAddress) {
        requestUrl = format(TELEMETRY_URL_FORMAT, groupSmtpAddress);
    } else {
        requestUrl = format(TELEMETRY_URL_FORMAT, USER_MAILBOX_ID);
    }

    await makePostRequest(
        requestUrl,
        JSON.stringify(payload),
        'Telemetry',
        payload.correlationVector
    );
}
